<template>
	<div class="create-post">
		<v-dialog
			v-model="dialog"
			content-class="lead-form-list-dialog"
			persistent
			transition="dialog-bottom-transition">
			<div class="lead-form-list-dialog-container">
				<div class="buttons-section flex">
					<div class="flex" style="width: 100%">
						<button class="back" @click="$emit('close')">
							<v-icon color="#1F8F58" size="25"
								>mdi-arrow-left</v-icon
							>
						</button>
						<h2 class="--green pointer">Inquiry Forms</h2>
						<!-- <h2 class="ml-3 secondary-font">Products</h2> -->
						<v-spacer />
						<button
							class="createBtn flex --green --weight"
							v-ripple
							@click="openCreateNewFormModal">
							<v-icon
								color="#1F8F58"
								size="25"
								style="margin-right: 8px"
								>mdi-plus</v-icon
							>Create New
							<v-progress-circular indeterminate size="15" class="mx-2" width="2" v-if="createNewLoader"/>
						</button>
					</div>
				</div>
				<v-progress-linear indeterminate class="my-2" color="#1F8F58" v-if="loader"/>
				<div style="margin-top: 2rem">
					<form-list v-for="(form, index) in formList" :key="index" :data="form" @formDetails="setFormDetails"/>
                	<infinite-scroll 
						:data="{page : formListPage, total : formListCount, perPage : formDataPerPage}" 
						@appendList="formListPage += 1; getFormList('append');"/>
				</div>
			</div>
		</v-dialog>
    	<create-lead-form ref="createFormRef" :dialog="createNewFormModal" @close="createNewFormModal = false; getFormList();"/>
		<form-detail :data="formDetails" :dialog="formDetailsDialog" @close="formDetails = {}; formDetailsDialog = false;"/>
	</div>
</template>

<script>
import formList from "../../ActiveLeads/components/form-list-card.vue";
import infiniteScroll from "../../Common/infinite-scroll.vue";
import createLeadGenerationForm from "../../ActiveLeads/components/create-lead-generation-form.vue";
import { eventBus } from '../../../../main';
import leadFormDetails from "../../ActiveLeads/components/form-details.vue";
export default {
	name: "leadFormList",

	data() {
		return {
			createNewFormModal : false,
			formIdentifier : {},
			createNewLoader : false,
			loader : false,
			formListPage : 1,
            formDataPerPage : 20,
			formDetailsDialog : false,
			formDetails : {}
		};
	},

	computed : {
		formList() {
			return this.$store.getters['activeLeadsStore/GET_FORM_LIST'];
		},

		formListCount() {
            return this.$store.getters['activeLeadsStore/GET_FORM_TOTAL_COUNT']
        }
	},

	props : {
		dialog : {
			type : Boolean
		}
	},

	watch : {
		formList : function(value) {
			if(value.length)
				this.loader = false;
		}
	}, 

	mounted() {
        eventBus.$on('setFormIdentifier', data => {
			console.log("DATA FORM IDENTIFIER", data);
            this.formIdentifier = data; 
        })
    },

	methods : {
		getFormList(type = null) {
			this.loader = true;
			this.$store.dispatch('activeLeadsStore/getFormList', {type : type, page : this.formListPage, perPage : this.formDataPerPage});
		},

		openCreateNewFormModal() {
			this.createNewFormModal = true;
			this.$refs.createFormRef.getFormConfigs();
		},

		setFormDetails(data) {
			this.formDetails = data;
			this.formDetailsDialog = true;
		}
	},

	components: {
		"form-list": formList,
		"create-lead-form" : createLeadGenerationForm,
		"form-detail" : leadFormDetails,
		"infinite-scroll" : infiniteScroll
	},
};
</script>

<style lang="scss" scoped>
.lead-form-list-dialog-container {
	background-color: white;
	font-family: Roboto;
	padding: 20px;
}

.buttons-section {
	justify-content: space-between;
}
.list-section {
	justify-content: space-between;
	border-radius: 5px;
	border-bottom: black;
	border-bottom: 2px #f1eded solid;
	border-right: 2px solid #f1eded;
	padding: 2px;
}

button {
	border-radius: 5px;
	font-size: 1rem;
	padding: 10px 0;
}

.back {
	width: 50px;
	height: 50px;
	border-radius: 7px;
	margin-right: 10px;
	background: rgba(49, 138, 54, 0.05);
}

.createBtn {
	width: 24%;
	background: rgba(49, 138, 54, 0.05);
	justify-content: center;
}
</style>

<style lang="scss">
.lead-form-list-dialog.v-dialog {
	width: 60%;
	min-height: 600px;
	background-color: white;
}

.create-content-input fieldset {
	color: white !important;
}

@media all and (min-width: 1500px) {
	.lead-form-list-dialog.v-dialog {
		width: 50%;
	}
}
</style>
